import React from "react";
import "./Plan.css";
import {Link} from 'react-router-dom'
export default function Plan() {
  return (
    <div className="plan-container">
      <div className="plan-container-fisrt">
        <div>
          <p>1.00</p>
          <p>Total Credits</p>
        </div>
        <div>
          <p>0.00</p>
          <p>Subscription Credits</p>
        </div>
        <div>
          <p>1.00</p>
          <p>Pay as you go Credits</p>
        </div>
        <div>
          <p>50 of 50</p>
          <p>Free Previews via API</p>
        </div>
      </div>
      <div className="plan-container-second">
        <h3>Your plan and credits</h3>
        <div>
          <div>
            <h5>Free Plan</h5>
            <p>Non-commercial use only </p>
            <p>You get 0 new credits on Apr 30, 2022</p>
            <button
              style={{
                height: "50px",
                width: "180px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#2699FB",
                border: "none",
                borderRadius: "5px",
                padding: "5px"
              }}
            >
              Upgrade Subcription
            </button>
          </div>
          <div>
            <h5>Your Pay as you go credits</h5>
            <p>1 credits</p>
            <button
              style={{
                height: "50px",
                width: "120px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#2699FB",
                border: "none",
                borderRadius: "5px",
                padding: "5px"
              }}
            >
              Buy Credits
            </button>
          </div>
        </div>
      </div>
      <div className="plan-container-third">
        <h3>Account Log</h3>
        <div>
        <button>Usage Chart</button>
       <Link to="/history"><button>Images History</button></Link> 
        </div>
      </div>
    </div>
  );
}
